/* Blak Sand — the shelf (16 Sep 2026).
   1. Load more: fetches the next page of the same section and appends its cards.
   2. Auto-fetch: the same thing fires on its own when the sentinel nears the viewport,
      so the shelf is continuous; the button stays visible for anyone who prefers to tap.
   3. Her place: on tap of a card we remember how many pages were open and where she was,
      so a back-tap from the product page lands her on the same shoe, not at the top. */
(function () {
  'use strict';
  if (window.__bsShelf) return;
  window.__bsShelf = true;

  var KEY = 'bs-shelf:' + location.pathname + location.search;

  // If we are coming back to a place we remembered, take scroll restoration off the
  // browser now, before it fires on a page that does not yet hold all the cards.
  var savedEarly = null;
  try { savedEarly = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (savedEarly) { try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {} }

  function q(sel, root) { return (root || document).querySelector(sel); }

  function pageUrl(n) {
    var u = new URL(location.href);
    u.searchParams.set('page', n);
    return u;
  }

  function sectionUrl(n, sectionId) {
    var u = pageUrl(n);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function state() {
    var more = q('.bs-more');
    if (!more) return null;
    var wrap = more.closest('.bs-shelf-wrap') || document;
    return {
      more: more,
      grid: q('ul.bs-shelf', wrap),
      sectionId: more.getAttribute('data-section'),
      page: parseInt(more.getAttribute('data-page') || '1', 10),
      pages: parseInt(more.getAttribute('data-pages') || '1', 10)
    };
  }

  function fetchPage(n) {
    var s = state();
    if (!s || s.more.getAttribute('data-busy') === 'true') return Promise.resolve(false);
    if (n > s.pages) { s.more.setAttribute('data-done', 'true'); return Promise.resolve(false); }
    s.more.setAttribute('data-busy', 'true');
    return fetch(sectionUrl(n, s.sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('ul.bs-shelf > li');
        var frag = document.createDocumentFragment();
        items.forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
        s.grid.appendChild(frag);
        s.more.setAttribute('data-page', n);
        var nextBtn = q('.bs-more__btn', s.more);
        if (n >= s.pages) { s.more.setAttribute('data-done', 'true'); }
        else if (nextBtn) { nextBtn.setAttribute('href', pageUrl(n + 1).toString()); }
        s.more.removeAttribute('data-busy');
        return true;
      })
      .catch(function () { s.more.removeAttribute('data-busy'); return false; });
  }

  function loadNext() {
    var s = state();
    if (!s) return Promise.resolve(false);
    return fetchPage(s.page + 1);
  }

  // Load more — tap
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bs-more__btn');
    if (!btn) return;
    e.preventDefault();
    loadNext();
  });

  // Auto-fetch near the bottom
  var io;
  function watch() {
    if (io) io.disconnect();
    var sent = q('.bs-sentinel');
    if (!sent || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var s = state();
        if (!s || s.more.getAttribute('data-done') === 'true') return;
        loadNext();
      });
    }, { rootMargin: '900px 0px' });
    io.observe(sent);
  }

  // Her place — remember on tap, restore on return
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.bs-card');
    if (!card) return;
    var s = state();
    if (!s) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ page: s.page, y: window.scrollY, handle: card.getAttribute('data-bs-handle'), t: Date.now() }));
    } catch (err) {}
  });

  function restore() {
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; }
    if (!saved || Date.now() - saved.t > 30 * 60 * 1000) return;
    var s = state();
    if (!s) return;
    var chain = Promise.resolve();
    for (var n = s.page + 1; n <= Math.min(saved.page, s.pages); n++) {
      (function (k) { chain = chain.then(function () { return fetchPage(k); }); })(n);
    }
    chain.then(function () {
      var target = saved.handle && q('.bs-card[data-bs-handle="' + saved.handle + '"]');
      if (target) {
        var top = target.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo(0, Math.max(0, top));
      } else {
        window.scrollTo(0, saved.y || 0);
      }
      try { sessionStorage.removeItem(KEY); } catch (e) {}
    });
  }

  function init() {
    watch();
    restore();
  }

  // The sidebar filter swaps #ProductGridContainer wholesale; re-arm after it does.
  var root = document.getElementById('ProductGridContainer');
  if (root && 'MutationObserver' in window) {
    new MutationObserver(function () { watch(); }).observe(root, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) restore(); });
})();
